<script>
import { useAlert } from 'dashboard/composables';
import { LocalStorage } from 'shared/helpers/localStorage';
import { LOCAL_STORAGE_KEYS } from 'dashboard/constants/localStorage';
import { setColorTheme } from 'dashboard/helper/themeHelper.js';
import { emitter } from 'shared/helpers/mitt';

export default {
  name: 'ThemeSetting',
  data() {
    return {
      selectedTheme: 'light',
      themeOptions: [
        {
          key: 'light',
          label: this.$t('PROFILE_SETTINGS.FORM.APPEARANCE_SECTION.LIGHT'),
        },
        {
          key: 'dark',
          label: this.$t('PROFILE_SETTINGS.FORM.APPEARANCE_SECTION.DARK'),
        },
      ],
    };
  },
  mounted() {
    this.initializeTheme();
    
    // Lắng nghe event từ ThemeToggleSwitch
    emitter.on('theme-changed', this.handleThemeChanged);
  },
  beforeUnmount() {
    // Cleanup event listener
    emitter.off('theme-changed', this.handleThemeChanged);
  },
  methods: {
    initializeTheme() {
      const savedTheme = LocalStorage.get(LOCAL_STORAGE_KEYS.COLOR_SCHEME) || 'light';
      this.selectedTheme = savedTheme;
    },
    async updateTheme(theme) {
      try {
        this.selectedTheme = theme;
        LocalStorage.set(LOCAL_STORAGE_KEYS.COLOR_SCHEME, theme);
        
        const isOSOnDarkMode = window.matchMedia('(prefers-color-scheme: dark)').matches;
        setColorTheme(isOSOnDarkMode);
        
        // Emit event để đồng bộ với ThemeToggleSwitch
        emitter.emit('theme-changed', theme);
      } catch (error) {
      }
    },
    handleThemeChanged(theme) {
      // Cập nhật state khi nhận event từ ThemeToggleSwitch
      this.selectedTheme = theme;
    },
  },
};
</script>

<template>
  <div class="space-y-4">
    <!-- Theme options -->
    <div class="flex items-center space-x-6">
      <label
        v-for="theme in themeOptions"
        :key="theme.key"
        class="flex items-center cursor-pointer"
      >
        <input
          type="radio"
          :value="theme.key"
          :checked="selectedTheme === theme.key"
          class="sr-only"
          @change="updateTheme(theme.key)"
        />
        <div
          class="w-4 h-4 rounded-full border-[1px] flex items-center justify-center mr-2 bg-white"
          :class="{
            'border-green-500': selectedTheme === theme.key,
            'border-slate-300 dark:border-gray-300': selectedTheme !== theme.key,
          }"
        >
          <div
            v-if="selectedTheme === theme.key"
            class="w-2 h-2 rounded-full bg-green-500"
          ></div>
        </div>
        <span class="text-sm text-slate-700 dark:text-slate-300">
          {{ theme.label }}
        </span>
      </label>
    </div>
  </div>
</template>